import { IField, ISelect } from 'app/services/api5-service/api.interface';
import { map } from 'rxjs/operators';

import { RadioProps } from './model/radio-props.interface';

import {
  ISPFieldConfig,
  ISPFieldType,
  ISPFieldWrapper,
  ISPFormState,
} from '../../model';
import {
  isSelectShouldBeHidden,
  isSelectShouldBeHidden$,
} from '../select/select.utils';

/**
 * Get props for radio field
 *
 * @param control - control (subfield) metadata
 * @param field - field metadata
 * @param state - dynamic form state
 */
export function getRadioProps(
  control: ISelect,
  field: IField,
  state: ISPFormState,
): RadioProps {
  const options = state.selectService.getOptionsForSelect(control.$name) || [];
  const options$ = state.selectService
    .getOptionsForSelect$(control.$name, control.$depend)
    .pipe(map(o => o || []));

  return {
    originalControl: control,
    originalField: field,
    options$,
    inline: control.$inline === 'yes',
    isHidden: isSelectShouldBeHidden(state, control, field, options),
    isHidden$: isSelectShouldBeHidden$(state, control, field, options$),
  };
}
/**
 * Get config for radio field
 *
 * @param control - control (subfield) metadata
 * @param field - field metadata
 * @param state - dynamic form state
 */
export function getRadioConfig(
  control: ISelect,
  field: IField,
  state: ISPFormState,
): ISPFieldConfig<ISPFieldType.Radio> {
  const props = getRadioProps(control, field, state);

  const config: ISPFieldConfig<ISPFieldType.Radio> = {
    key: control.$name,
    type: ISPFieldType.Radio,
    wrappers: [ISPFieldWrapper.FieldBase, ISPFieldWrapper.ValidationError],
    props,
    // ispui radio doesn't implement blur event
    modelOptions: {
      updateOn: 'change',
    },
  };

  return config;
}
